module.exports = "/images/Marker.png?20e590ef331308a2cf50967103f95040";